export const termsMap: any = {
    eu: [
        {
            title: `<strong>Product Usage: </strong>`,
        },
        {
            title: '[1] Tested in a 10 cubic meter space at 77°F/25℃. Performance may vary with room size and temperature.',
        },
        {
            title: '[2] Tested in a 10 cubic meter space at 60°F/15℃. Results may differ depending on conditions.',
        },
        {
            title: '[3] 8 hours of wireless use in Eco Mode under optimal conditions. Battery life may vary based on usage and environment.',
        },
        {
            title: '<header><strong>EcoFlow WAVE 3 & GLACIER Classic Launch Campaign Terms & Conditions</strong></header>',
        },
        {
            title: '<strong>Campaign Duration</strong>',
        },
        {
            title: 'The EcoFlow WAVE 3 & GLACIER Classic Launch Campaign runs from 25 April 2025, 9 AM (CET) to 30 July 2025, 9 AM (CET). EcoFlow reserves the right to modify or extend the campaign period at its sole discretion without prior notice.',
        },
        {
            title: '<strong>Eligibility</strong>',
        },
        {
            title: 'The campaign is open to European citizens aged 18 and above as of 25 April 2025, 9:00 AM (CET).',
        },

        {
            title: '<strong>Availability</strong>',
        },
        {
            title: `This campaign, including promotions, gifts, and discounts, is available exclusively on <a href="https://eu.ecoflow.com" target="blank"> eu.ecoflow.com. </a>Purchases made on other platforms or websites are not eligible for campaign offers.`,
        },

        {
            title: '<strong>Campaign Details</strong>',
        },
        {
            title: '1. By providing your email address and subscribing, you agree to the Email Marketing Terms & Conditions, subscribe to EcoFlow marketing emails, and consent to receive updates from EcoFlow.',
        },
        {
            title: "2. Save €100 with the Early Bird Deal based on the Manufacturer's Suggested Retail Price (MSRP):",
        },
        {
            title:
                '<ul>' +
                '<li>EcoFlow WAVE 3 will launch on 12 May 2025 at 9 AM (CET). EcoFlow GLACIER Classic will be launched on 29 May 2025, 9 AM (CET). The Early Bird Deal is only valid during the first month of launch. EcoFlow reserves the right to stop, cancel, or change the promotion at any time during the promotion. Any changes will be announced on the EcoFlow official website.' +
                '</li>' +
                '<li>Products eligible for the Early Bird Deal*:' +
                '<ul>' +
                '<li>EcoFlow WAVE 3 + WAVE 3 Add-on Battery (Save €100 based on MSRP when purchased as a bundle)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35L + Plug-in Battery (Save €100 based on MSRP when purchased as a bundle)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45L + Plug-in Battery (Save €100 based on MSRP when purchased as a bundle)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55L + Plug-in Battery (Save €100 based on MSRP when purchased as a bundle)' +
                '</li>' +
                '<li>EcoFlow WAVE 3 (Save €100 based on MSRP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35L (Save €100 based on MSRP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45L (Save €100 based on MSRP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55L (Save €100 based on MSRP)' +
                '</li>' +
                '</ul>' +
                '</li>' +
                '<p class="outline-text">* This product list is for reference purposes only. Please refer to the product pages of EcoFlow WAVE 3 and EcoFlow GLACIER Classic on <a href="https://eu.ecoflow.com" target="blank"> eu.ecoflow.com. </a> for accurate and up-to-date details.</p>' +
                '<li>All Early Bird Deal offers are subject to availability. Once stock runs out, the offer will no longer be available.' +
                '</li>' +
                '<li>Unless otherwise stated, the Early Bird Deal cannot be used with any other offers or promotions running on our website.' +
                '</li>' +
                '<li>The products eligible for the Early Bird Deal are not eligible for 30-day price match offers.' +
                '</li>' +
                '<li>Refurbished products are not eligible for this event.' +
                '</li>' +
                '</ul>',
        },
        // {
        //     title: '3. Refurbished products are not eligible for this event.',
        // },
        // {
        //     title: '4. Order Count and Gift Allocation:',
        // },
        // {
        //     title: "<ul><li>The first 200 qualifying orders will be counted across the following five official EcoFlow websites: <a href='https://eu.ecoflow.com' target='blank'> eu.ecoflow.com </a>, <a href='https://de.ecoflow.com' target='blank'> de.ecoflow.com </a>, <a href='https://fr.ecoflow.com' target='blank'> fr.ecoflow.com </a>, <a href='https://it.ecoflow.com' target='blank'> it.ecoflow.com </a> and <a href='https://es.ecoflow.com' target='blank'> es.ecoflow.com </a> A total of 200 sets of Free Gifts will be distributed across these websites. The count begins based on the official website's announcement of the EcoFlow WAVE 3 & GLACIER Classic launch time. Eligible orders will be determined in chronological order of payment.</li></ul>",
        // },

        // {
        //     title: 'List of Eligible Products and Free Gifts',
        // },
        // {
        //     title: '<ul><li>Eligible Products: EcoFlow WAVE 3 Portable Air Conditioner and its bundles<ul><li>Dedicated Gifts:<ul><li>1 × EcoFlow WAVE Series Bag (MSRP €79)</li><li>1 × EcoFlow Velcro Strap Handle (MSRP €39)</li></ul></li><li>Available Quantities: 200 sets</li></ul></li><li>Eligible Products: EcoFlow GLACIER Classic Portable Fridge Freezer and its bundles<ul><li>Dedicated Gifts:<ul><li>1 × EcoFlow Power Hat* (MSRP €99)</li><li>1 × EcoFlow Camping Mug (MSRP €22)</li><p class="outline-text">*The EcoFlow Power Hat is provided in random sizes (M or L) based on available stock. Size selection is not available.</p></ul></li><li>Available Quantities: 200 sets</li></ul></li></ul>',
        // },
        // {
        //     title: '5. Once 200 qualifying orders have been placed, the special offer for the first 200 purchases will automatically end without further notice. Once Free Gift stock is exhausted, it will no longer be available for new orders.',
        // },
        // {
        //     title: '6. The special offer for the first 200 purchases cannot be used in conjunction with any other offers or promotions running on our website unless otherwise stated.',
        // },
        // {
        //     title: '7. If an order qualifies for Free Gifts, they will be automatically added within 24 hours of payment. Purchasers can check their order update email after 24 hours or register for an EcoFlow account and log in to the <a href="https://account.ecoflow.com/login?return_to=eu.ecoflow.com/" target="blank"> EcoFlow Account Portal </a> to confirm the addition of Free Gifts to their order.',
        // },
        // {
        //     title: '8. Shipping of Free Gifts:',
        // },
        // {
        //     title: '<ul><li>If an order is a pre-order, the Free Gifts will not be shipped earlier than the EcoFlow WAVE 3 Portable Air Conditioner or the EcoFlow GLACIER Classic Portable Fridge Freezer.</li><li>When the EcoFlow WAVE 3 or EcoFlow GLACIER Classic is restocked, the Free Gifts will be shipped together with the main product.</li></ul>',
        // },
        // {
        //     title: '9. Return Policy:',
        // },
        // {
        //     title: "<ul><li>If a customer wishes to return an order or item that qualified for Free Gifts, the transaction can only be refunded if the Free Gifts are also returned.</li><li>The value of the Free Gifts is based on the Manufacturer's Suggested Retail Price (MSRP).</li><li>If the Free Gift is not returned, EcoFlow reserves the right to deduct the value of the Free Gift from the refund amount.</li></ul>",
        // },
        // {
        //     title: '10. Restrictions on Free Gifts:',
        // },
        // {
        //     title: '<ul><li>Free Gifts cannot be applied to orders placed before the campaign starts.</li><li>Free Gifts are non-transferable, non-reusable, and cannot be shared without authorisation.</li><li>Free Gifts cannot be exchanged for any other item, cash, or credit.</li></ul>',
        // },
        {
            title: '<header><strong>General:</strong></header>',
        },
        {
            title: "1. If you encounter any problems during the promotion, please contact <a  href='mailto:support.eu@ecoflow.com'> support.eu@ecoflow.com </a> for assistance.",
        },
        {
            title: '2. To the extent permitted by applicable law, we may decide to modify these rules or cancel the promotion at any time. If there is any fraud or abuse related to the promotion, we reserve the right to exclude any customer from the promotion.',
        },
        {
            title: "3. Participants in the Sale agree to be bound by the terms and conditions set forth herein and understand that EcoFlow's decisions are final and binding. No correspondence or appeals will be entertained. EcoFlow reserves the right to make the final and ultimate interpretation of this campaign.",
        },
        {
            title: "4. All orders must comply with EcoFlow's purchase agreement and return policy during the sale promotion.",
        },
        {
            title: '5. The sale promotion does not apply to wholesale or distributor orders.',
        },
        {
            title: '6. Any unauthorised or fraudulent behaviour will result in the disqualification of participants.',
        },
        {
            title: '7. Participants must comply with all applicable laws and regulations.',
        },
        {
            title: '8. EcoFlow reserves the right to stop, cancel, or change the promotion at any time during the promotion. Any changes will be announced on the EcoFlow official website.',
        },
        {
            title: "9. All prizes in this promotion are limited in quantity and are available on a first-come, first-served basis. Any matters not covered herein will be handled according to EcoFlow's final interpretation.",
        },
        {
            title: '10. EcoFlow will assume no responsibility for late entries, which may occur for any reason, including but not limited to network transmission failure.',
        },
        {
            title: '11. EcoFlow will not be responsible for any direct or indirect losses or damages incurred by any party, including participants, in connection with or arising from any acts or omissions, or in any way related to this campaign.',
        },
        {
            title: "12. Participants agree to release and discharge EcoFlow from any liabilities and claims, including breach of contract, tort, negligence, or any other cause of action at law or equity, arising out of or in any way connected to this campaign or the participant's entry into the campaign.",
        },
        {
            title: "13. All products and free gifts (if applicable) related to this promotion will be shipped in accordance with EcoFlow's Shipping Policy (<a href='https://eu.ecoflow.com/policies/shipping-policy' target='blank'>https://eu.ecoflow.com/policies/shipping-policy</a>)",
        },
        {
            title: '14. There may be instances where EcoFlow is unable to accept or must cancel certain orders. EcoFlow reserves the right, at its sole discretion, to refuse or cancel any order for any reason. In such cases, EcoFlow is not responsible for any inaccuracies, errors, or potential consequences arising from the cancellation.',
        },
    ],
    uk: [
        {
            title: `<strong>Product Usage: </strong>`,
        },
        {
            title: '[1] Tested in a 10 cubic meter space at 77°F/25℃. Performance may vary with room size and temperature.',
        },
        {
            title: '[2] Tested in a 10 cubic meter space at 60°F/15℃. Results may differ depending on conditions.',
        },
        {
            title: '[3] 8 hours of wireless use in Eco Mode under optimal conditions. Battery life may vary based on usage and environment.',
        },
        {
            title: '<header><strong>EcoFlow WAVE 3 & GLACIER Classic Launch Campaign Terms & Conditions</strong></header>',
        },
        {
            title: '<strong>Campaign Duration</strong>',
        },
        {
            title: 'The EcoFlow WAVE 3 & GLACIER Classic Launch Campaign runs from 25 April 2025, 8 AM (BST) to 30 July 2025, 8 AM (BST). EcoFlow reserves the right to modify or extend the campaign period at its sole discretion without prior notice.',
        },
        {
            title: '<strong>Eligibility</strong>',
        },
        {
            title: 'The campaign is open to UK citizens aged 18 and above as of 25 April 2025, 8:00 AM (BST).',
        },

        {
            title: '<strong>Availability</strong>',
        },
        {
            title: `This campaign, including promotions, gifts, and discounts, is available exclusively on <a href="https://uk.ecoflow.com" target="blank"> uk.ecoflow.com. </a>Purchases made on other platforms or websites are not eligible for campaign offers.`,
        },

        {
            title: '<strong>Campaign Details</strong>',
        },
        {
            title: '1. By providing your email address and subscribing, you agree to the Email Marketing Terms & Conditions, subscribe to EcoFlow marketing emails, and consent to receive updates from EcoFlow.',
        },
        {
            title: "2. Save £100 with the Early Bird Deal based on the Manufacturer's Suggested Retail Price (MSRP):",
        },
        {
            title:
                '<ul>' +
                '<li>EcoFlow WAVE 3 will launch on 12 May 2025 at 8 AM (BST). EcoFlow GLACIER Classic will be launched on 29 May 2025, 8 AM (BST). The Early Bird Deal is only valid during the first month of launch. EcoFlow reserves the right to stop, cancel, or change the promotion at any time during the promotion. Any changes will be announced on the EcoFlow official website.' +
                '</li>' +
                '<li>Products eligible for the Early Bird Deal*:' +
                '<ul>' +
                '<li>EcoFlow WAVE 3 + WAVE 3 Add-on Battery (Save £100 based on MSRP when purchased as a bundle)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35L + Plug-in Battery (Save £100 based on MSRP when purchased as a bundle)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45L + Plug-in Battery (Save £100 based on MSRP when purchased as a bundle)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55L + Plug-in Battery (Save £100 based on MSRP when purchased as a bundle)' +
                '</li>' +
                '<li>EcoFlow WAVE 3 (Save £100 based on MSRP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35L (Save £100 based on MSRP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45L (Save £100 based on MSRP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55L (Save £100 based on MSRP)' +
                '</li>' +
                '</ul>' +
                '</li>' +
                '<p class="outline-text">* This product list is for reference purposes only. Please refer to the product pages of EcoFlow WAVE 3 and EcoFlow GLACIER Classic on <a href="https://uk.ecoflow.com" target="blank"> uk.ecoflow.com. </a> for accurate and up-to-date details.</p>' +
                '<li>All Early Bird Deal offers are subject to availability. Once stock runs out, the offer will no longer be available.' +
                '</li>' +
                '<li>Unless otherwise stated, the Early Bird Deal cannot be used with any other offers or promotions running on our website.' +
                '</li>' +
                '<li>The products eligible for the Early Bird Deal are not eligible for 30-day price match offers.' +
                '</li>' +
                '<li>Refurbished products are not eligible for this event.' +
                '</li>' +
                '</ul>',
        },
        // {
        //     title: '2. The first 100 orders of the EcoFlow WAVE 3 Portable Air Conditioner, EcoFlow GLACIER Classic Portable Fridge Freezer, and their bundles placed between 8:00 AM on 29 May and 8:00 AM on 30 July will receive Free Gifts. Free Gifts are available while stocks last. Each order is eligible for only one set of gifts.',
        // },
        // {
        //     title: '3. Refurbished products are not eligible for this event.',
        // },
        // {
        //     title: '4. Order Count and Gift Allocation:',
        // },
        // {
        //     title: "<ul><li>The first 100 qualifying orders will be counted on the official EcoFlow UK website(<a href='https://uk.ecoflow.com' target='blank'>uk.ecoflow.com</a>).  A total of 100 sets of Free Gifts will be given away. The count begins based on the official website's announcement of the EcoFlow WAVE 3 & GLACIER Classic launch time. Eligible orders will be determined in chronological order of payment.</li></ul>",
        // },

        // {
        //     title: 'List of Eligible Products and Free Gifts',
        // },
        // {
        //     title: '<ul><li>Eligible Products: EcoFlow WAVE 3 Portable Air Conditioner and its bundles<ul><li>Dedicated Gifts:<ul><li>1 × EcoFlow WAVE Series Bag (MSRP £69)</li><li>1 × EcoFlow Velcro Strap Handle (MSRP £35)</li></ul></li><li>Available Quantities: 100 sets</li></ul></li><li>Eligible Products: EcoFlow GLACIER Classic Portable Fridge Freezer and its bundles<ul><li>Dedicated Gifts:<ul><li>1 × EcoFlow Power Hat* (MSRP £99)</li><li>1 × EcoFlow Camping Mug (MSRP £22)</li><p class="outline-text">*The EcoFlow Power Hat is provided in random sizes (M or L) based on available stock. Size selection is not available.</p></ul></li><li>Available Quantities: 100 sets</li></ul></li></ul>',
        // },
        // {
        //     title: '5. Once 100 qualifying orders have been placed, the special offer for the first 100 purchases will automatically end without further notice. Once Free Gift stock is exhausted, it will no longer be available for new orders.',
        // },
        // {
        //     title: '6. The special offer for the first 100 purchases cannot be used in conjunction with any other offers or promotions running on our website unless otherwise stated.',
        // },
        // {
        //     title: '7. If an order qualifies for Free Gifts, they will be automatically added within 24 hours of payment. Purchasers can check their order update email after 24 hours or register for an EcoFlow account and log in to the <a href="https://account.ecoflow.com/login?return_to=uk.ecoflow.com/" target="blank"> EcoFlow Account Portal </a> to confirm the addition of Free Gifts to their order.',
        // },
        // {
        //     title: '8. Shipping of Free Gifts:',
        // },
        // {
        //     title: '<ul><li>If an order is a pre-order, the Free Gifts will not be shipped earlier than the EcoFlow WAVE 3 Portable Air Conditioner or the EcoFlow GLACIER Classic Portable Fridge Freezer.</li><li>When the EcoFlow WAVE 3 or EcoFlow GLACIER Classic is restocked, the Free Gifts will be shipped together with the main product.</li></ul>',
        // },
        // {
        //     title: '9. Return Policy:',
        // },
        // {
        //     title: "<ul><li>If a customer wishes to return an order or item that qualified for Free Gifts, the transaction can only be refunded if the Free Gifts are also returned.</li><li>The value of the Free Gifts is based on the Manufacturer's Suggested Retail Price (MSRP).</li><li>If the Free Gift is not returned, EcoFlow reserves the right to deduct the value of the Free Gift from the refund amount.</li></ul>",
        // },
        // {
        //     title: '10. Restrictions on Free Gifts:',
        // },
        // {
        //     title: '<ul><li>Free Gifts cannot be applied to orders placed before the campaign starts.</li><li>Free Gifts are non-transferable, non-reusable, and cannot be shared without authorisation.</li><li>Free Gifts cannot be exchanged for any other item, cash, or credit.</li></ul>',
        // },
        {
            title: '<header><strong>General:</strong></header>',
        },
        {
            title: "1. If you encounter any problems during the promotion, please contact <a  href='mailto:support.eu@ecoflow.com'>  support.eu@ecoflow.com  </a> for assistance.",
        },
        {
            title: '2. To the extent permitted by applicable law, we may decide to modify these rules or cancel the promotion at any time. If there is any fraud or abuse related to the promotion, we reserve the right to exclude any customer from the promotion.',
        },
        {
            title: "3. Participants in the Sale agree to be bound by the terms and conditions set forth herein and understand that EcoFlow's decisions are final and binding. No correspondence or appeals will be entertained. EcoFlow reserves the right to make the final and ultimate interpretation of this campaign.",
        },
        {
            title: "4. All orders must comply with EcoFlow's purchase agreement and return policy during the sale promotion.",
        },
        {
            title: '5. The sale promotion does not apply to wholesale or distributor orders.',
        },
        {
            title: '6. Any unauthorised or fraudulent behaviour will result in the disqualification of participants.',
        },
        {
            title: '7. Participants must comply with all applicable laws and regulations.',
        },
        {
            title: '8. EcoFlow reserves the right to stop, cancel, or change the promotion at any time during the promotion. Any changes will be announced on the EcoFlow official website.',
        },
        {
            title: "9. All prizes in this promotion are limited in quantity and are available on a first-come, first-served basis. Any matters not covered herein will be handled according to EcoFlow's final interpretation.",
        },
        {
            title: '10. EcoFlow will assume no responsibility for late entries, which may occur for any reason, including but not limited to network transmission failure.',
        },
        {
            title: '11. EcoFlow will not be responsible for any direct or indirect losses or damages incurred by any party, including participants, in connection with or arising from any acts or omissions, or in any way related to this campaign.',
        },
        {
            title: "12. Participants agree to release and discharge EcoFlow from any liabilities and claims, including breach of contract, tort, negligence, or any other cause of action at law or equity, arising out of or in any way connected to this campaign or the participant's entry into the campaign.",
        },
        {
            title: "13. All products and free gifts (if applicable) related to this promotion will be shipped in accordance with EcoFlow's Shipping Policy (<a href='https://uk.ecoflow.com/policies/shipping-policy' target='blank'>https://uk.ecoflow.com/policies/shipping-policy</a>)",
        },
        {
            title: '14. There may be instances where EcoFlow is unable to accept or must cancel certain orders. EcoFlow reserves the right, at its sole discretion, to refuse or cancel any order for any reason. In such cases, EcoFlow is not responsible for any inaccuracies, errors, or potential consequences arising from the cancellation.',
        },
    ],
    de: [
        {
            title: `<strong>Produktverwendung: </strong>`,
        },
        {
            title: '[1] Getestet in einem 10 m³ Raum bei 25 °C. Die Leistung kann je nach Raumgröße und Temperatur variieren.',
        },
        {
            title: '[2] Getestet in einem 10 m³ Raum bei 15 °C. Ergebnisse können je nach Bedingungen abweichen.',
        },
        {
            title: '[3] 8 Stunden kabelloser Betrieb im Eco Modus unter optimalen Bedingungen. Die Batterielaufzeit kann je nach Nutzung und Umgebung variieren.',
        },
        {
            title: '<header><strong>Allgemeine Geschäftsbedingungen für die EcoFlow WAVE 3 & GLACIER Classic Launch Kampagne</strong></header>',
        },
        {
            title: '<strong>Aktionszeitraum</strong>',
        },
        {
            title: 'Die EcoFlow WAVE 3 & GLACIER Classic Launch Kampagne läuft vom 25. April 2025, 9:00 Uhr (MEZ) bis zum 30. Juli 2025, 9:00 Uhr (MEZ). EcoFlow behält sich das Recht vor, den Kampagnenzeitraum nach eigenem Ermessen und ohne vorherige Ankündigung zu verkürzen oder zu verlängern.',
        },
        {
            title: '<strong>Berechtigung</strong>',
        },
        {
            title: 'Die Kampagne steht europäischen Bürgern offen, die am 25. April 2025, 9:00 Uhr (MEZ) mindestens 18 Jahre alt oder älter sind.',
        },

        {
            title: '<strong>Verfügbarkeit</strong>',
        },
        {
            title: `Diese Kampagne, einschließlich Werbeaktionen, Geschenken und Rabatten, ist exklusiv auf <a href="https://de.ecoflow.com" target="blank"> de.ecoflow.com </a>verfügbar. Für Einkäufe auf anderen Plattformen oder Websites gelten die Angebote der Kampagne nicht.`,
        },
        {
            title: '<strong>Kampagnendetails</strong>',
        },
        {
            title: '1. Durch Eingabe Ihrer E-Mail Adresse und Ihrer Anmeldung stimmen Sie den Allgemeinen Geschäftsbedingungen für E-Mail Marketing zu, abonnieren EcoFlow Marketing E-Mails und erhalten Updates von EcoFlow.',
        },
        {
            title: '2. Sparen Sie 100 € mit dem Frühbucherangebot basierend auf dem unverbindlichen Verkaufspreis (UVP) des Herstellers:',
        },
        {
            title:
                '<ul>' +
                '<li>EcoFlow WAVE 3 startet am 12. Mai 2025 um 9.00 Uhr (MEZ). EcoFlow GLACIER Classic wird am 29. Mai 2025, 9.00 Uhr (MEZ) auf den Markt kommen. Das Frühbucherangebot ist nur während des ersten Monats gültig. EcoFlow behält sich das Recht vor, die Aktion jederzeit zu beenden, abzubrechen oder zu ändern. Alle Änderungen werden auf der offiziellen EcoFlow Webseite bekannt gegeben.' +
                '</li>' +
                '<li>Verfügbare Produkte für das Frühbucherangebot*:' +
                '<ul>' +
                '<li>EcoFlow WAVE 3 + WAVE 3 Zusatzbatterie (Bundle-Vorteil: 100 € Ersparnis gegenüber der UVP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35L + Plug-in-Batterie (Bundle-Vorteil: 100 € Ersparnis gegenüber der UVP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45L + Plug-in-Batterie (Bundle-Vorteil: 100 € Ersparnis gegenüber der UVP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55L + Plug-in-Batterie (Bundle-Vorteil: 100 € Ersparnis gegenüber der UVP)' +
                '</li>' +
                '<li>EcoFlow WAVE 3 (100 € günstiger im Vergleich zur UVP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35L (100 € günstiger im Vergleich zur UVP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45L (100 € günstiger im Vergleich zur UVP)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55L (100 € günstiger im Vergleich zur UVP)' +
                '</li>' +
                '</ul>' +
                '</li>' +
                '<p class="outline-text">    *Diese Produktliste dient nur zu Referenzzwecken. Genaue und aktuelle Details entnehmen Sie bitte den Produktseiten von EcoFlow WAVE 3 und EcoFlow GLACIER Classic auf <a href="https://de.ecoflow.com" target="blank"> de.ecoflow.com </a>.' +
                '<li>Alle Frühbucherangebote unterliegen der Verfügbarkeit. Sobald der Vorrat aufgebraucht ist, wird das Angebot nicht mehr verfügbar sein.' +
                '</li>' +
                '<li>Sofern nicht anders angegeben, kann das Frühbucherangebot nicht mit anderen Angeboten oder Aktionen auf unserer Website verwendet werden.' +
                '</li>' +
                '<li>Die Produkte, die für das Frühbucherangebot berechtigt sind, sind von jeglichen 30-Tage-Preisgarantie-Angeboten ausgeschlossen.' +
                '</li>' +
                '<li>Generalüberholte Produkte sind für diese Aktion nicht zugelassen.' +
                '</li>' +
                '</ul>',
        },
        // {
        //     title: '3. Generalüberholte Produkte sind für diese Aktion nicht zugelassen.',
        // },
        // {
        //     title: '4. Bestellanzahl und Geschenkzuordnung:',
        // },
        // {
        //     title: "<ul><li>Die ersten 200 qualifizierenden Bestellungen werden über die folgenden fünf offiziellen EcoFlow Websites gezählt: <a href='https://eu.ecoflow.com' target='blank'> eu.ecoflow.com </a>, <a href='https://de.ecoflow.com' target='blank'> de.ecoflow.com </a>, <a href='https://fr.ecoflow.com' target='blank'> fr.ecoflow.com </a>, <a href='https://it.ecoflow.com' target='blank'> it.ecoflow.com </a> und <a href='https://es.ecoflow.com' target='blank'> es.ecoflow.com </a> Insgesamt werden 200 Sets von Geschenken auf diesen Websites verteilt.  Die Zählung beginnt basierend auf der offiziellen Ankündigung des Verkaufsstarts von EcoFlow WAVE 3 & GLACIER Classic. Berechtigte Bestellungen werden in chronologischer Reihenfolge der Zahlung festgelegt.</li></ul>",
        // },

        // {
        //     title: 'Liste der berechtigten Produkte und Geschenke',
        // },
        // {
        //     title: '<ul><li>Berechtigte Produkte: EcoFlow WAVE 3 Tragbare Klimaanlage und deren Bundles<ul><li>Exklusive Geschenke:<ul><li>1 × EcoFlow WAVE Serie Tasche (UVP 79 €)</li><li>1 × EcoFlow Klettband-Griff (UVP 39 €)</li></ul></li><li>Verfügbare Mengen: 200 Sets</li></ul></li><li>Berechtigte Produkte: EcoFlow GLACIER Classic Tragbare Kühl- und Gefrierbox und deren Bundles<ul><li>Exklusive Geschenke:<ul><li>1 × EcoFlow Solar Hut* (UVP 99 €)</li><li>1 × EcoFlow Campingbecher (UVP 22 €)</li><p class="outline-text">*Der EcoFlow Solar Hut wird in zufälligen Größen (M oder L) je nach Verfügbarkeit geliefert. Eine Größenwahl ist nicht möglich.</p></ul></li><li>Verfügbare Mengen: 200 Sets</li></ul></li></ul>',
        // },
        // {
        //     title: '5. Nach 200 teilnahmeberechtigten Bestellungen endet das Aktionsangebot für die ersten 200 Bestellungen automatisch und ohne weitere Ankündigung. Sobald der Geschenkbestand aufgebraucht ist, können keine neuen Bestellungen mehr aufgegeben werden.',
        // },
        // {
        //     title: '6. Das Sonderangebot für die ersten 200 Käufe kann nicht mit anderen Angeboten oder Aktionen auf unserer Website kombiniert werden, es sei denn, es wird ausdrücklich anders angegeben.',
        // },
        // {
        //     title: '7. Wenn eine Bestellung für Geschenke qualifiziert, werden diese automatisch innerhalb von 24 Stunden nach Zahlungseingang hinzugefügt. Sie können nach 24 Stunden ihre Bestellbestätigungs-E-Mail überprüfen oder ein EcoFlow Konto registrieren und sich im <a href="https://account.ecoflow.com/login?return_to=de.ecoflow.com/" target="blank"> EcoFlow Account Portal </a> einloggen, um die Hinzufügung der Geschenke zu bestätigen.',
        // },
        // {
        //     title: '8. Versand der Gratisgeschenke:',
        // },
        // {
        //     title: '<ul><li>Handelt es sich bei der Bestellung um eine Vorbestellung, werden die Geschenke nicht früher versendet als die EcoFlow WAVE 3 Tragbare Klimaanlage oder die EcoFlow GLACIER Classic Tragbare Kühl- und Gefrierbox.</li><li>Sobald die EcoFlow WAVE 3 oder EcoFlow GLACIER Classic wieder auf Lager sind, werden die Geschenke gemeinsam mit dem Hauptprodukt versendet.</li></ul>',
        // },
        // {
        //     title: '9. Rückgaberecht:',
        // },
        // {
        //     title: '<ul><li>Wenn ein Kunde eine Bestellung oder einen Artikel zurückgeben möchte, der für Geschenke qualifiziert war, kann die Transaktion nur erstattet werden, wenn auch die Geschenke zurückgegeben werden.</li><li>Der Wert der Geschenke richtet sich nach der unverbindlichen Preisempfehlung (UVP) des Herstellers.</li><li>Wird das Geschenk nicht zurückgegeben, behält sich EcoFlow das Recht vor, den Wert des Geschenks vom Erstattungsbetrag abzuziehen.</li></ul>',
        // },
        // {
        //     title: '10. Einschränkungen für Geschenke:',
        // },
        // {
        //     title: '<ul><li>Geschenke können nicht auf Bestellungen angewendet werden, die vor Beginn der Kampagne aufgegeben wurden.</li><li>Geschenke sind nicht übertragbar, nicht wiederverwendbar und dürfen ohne Genehmigung nicht geteilt werden.</li><li>Geschenke können nicht gegen andere Artikel, Bargeld oder Guthaben eingetauscht werden.</li></ul>',
        // },
        {
            title: '<header><strong>Allgemein:</strong></header>',
        },
        {
            title: "1. Bitte wenden Sie sich an <a  href='mailto:support.eu@ecoflow.com'> support.eu@ecoflow.com</a>, wenn Sie während der Aktion auf Probleme stoßen.",
        },
        {
            title: '2. Diese Regeln können von uns jederzeit geändert oder die Werbeaktion kann von uns jederzeit abgebrochen werden, soweit dies nach geltendem Recht zulässig ist. Bei Betrug oder Missbrauch im Zusammenhang mit der Aktion behalten wir uns das Recht vor, Kunden von der Aktion auszuschließen.',
        },
        {
            title: '3. Die Teilnehmer an der Aktion erklären sich mit diesen Bedingungen einverstanden und erkennen an, dass die Entscheidungen von EcoFlow endgültig und bindend sind. Korrespondenz oder Einsprüche werden nicht entgegengenommen. EcoFlow behält sich das Recht auf die endgültige und abschließende Auslegung dieser Aktion vor.',
        },
        {
            title: '4. Alle Bestellungen innerhalb des Aktionszeitraums müssen den Kauf- und Rückgabebedingungen von EcoFlow entsprechen.',
        },
        {
            title: '5. Die Werbeaktion gilt nicht für Bestellungen von Großhändlern oder Distributoren.',
        },
        {
            title: '6. Jegliches unbefugte oder betrügerische Verhalten führt zur Disqualifikation der Teilnehmer.',
        },
        {
            title: '7. Die Teilnehmer müssen sich an alle geltenden Gesetze und Vorschriften halten.',
        },
        {
            title: '8. EcoFlow behält sich das Recht vor, die Aktion jederzeit zu beenden, abzubrechen oder zu ändern. Alle Änderungen werden auf der offiziellen EcoFlow Webseite bekannt gegeben.',
        },
        {
            title: '9. Alle in dieser Aktion angebotenen Preise sind in ihrer Anzahl begrenzt und werden in der Reihenfolge der Anmeldungen vergeben. Alle hierin nicht behandelten Angelegenheiten werden gemäß der endgültigen Auslegung von EcoFlow behandelt.',
        },
        {
            title: '10. EcoFlow übernimmt keine Verantwortung für verspätete Einträge, die aus irgendeinem Grund auftreten können, einschließlich, aber nicht beschränkt auf Netzwerkübertragungsfehler.',
        },
        {
            title: '11. EcoFlow haftet nicht für direkte oder indirekte Verluste oder Schäden, die einer Partei, einschließlich der Teilnehmer, in Verbindung mit oder aufgrund von Handlungen oder Unterlassungen oder in irgendeiner Weise im Zusammenhang mit dieser Kampagne entstehen.',
        },
        {
            title: '12. Die Teilnehmer erklären sich damit einverstanden, EcoFlow von jeglicher Haftung und von allen Ansprüchen freizustellen und zu entlasten, einschließlich von Ansprüchen aus Vertragsbruch, unerlaubter Handlung, Fahrlässigkeit oder anderen Klagegründen, die sich aus dieser Aktion oder der Mitwirkung des Teilnehmers an der Aktion ergeben oder in irgendeiner Weise damit in Zusammenhang stehen.',
        },
        {
            title: "13. Alle Produkte und Gratisgeschenke (falls zutreffend) im Zusammenhang mit dieser Aktion werden gemäß den Versandrichtlinien von EcoFlow (<a href='https://de.ecoflow.com/policies/shipping-policy' target='blank'>https://de.ecoflow.com/policies/shipping-policy</a>) versandt.",
        },
        {
            title: '14. Es kann Fälle geben, in denen EcoFlow eine Bestellung nicht annehmen oder stornieren muss. EcoFlow behält sich das Recht vor, nach eigenem Ermessen Bestellungen aus beliebigen Gründen abzulehnen oder zu stornieren. In solchen Fällen übernimmt EcoFlow keine Verantwortung für Ungenauigkeiten, Fehler oder mögliche Konsequenzen, die sich aus der Stornierung ergeben.',
        },
    ],
    fr: [
        {
            title: `<strong>Utilisation du produit : </strong>`,
        },
        {
            title: '[1] Testé dans un espace de 10 mètres cubes à 25 ℃. Les performances peuvent varier en fonction de la taille et de la température de la pièce.',
        },
        {
            title: '[2] Testé dans un espace de 10 mètres cubes à 15 ℃. Les résultats peuvent différer selon les conditions.',
        },
        {
            title: `[3] 8 heures d'utilisation sans fil en mode Eco dans des conditions optimales. La durée de vie de la batterie peut varier en fonction de son utilisation et des conditions environnementales.`,
        },
        {
            title: '<header><strong>Conditions générales de la période promotionnelle de lancement EcoFlow WAVE 3 et GLACIER Classic</strong></header>',
        },

        {
            title: '<strong>Période promotionnelle</strong>',
        },
        {
            title: 'La période promotionnelle de lancement EcoFlow WAVE 3 et GLACIER Classic se déroule du 25 avril 2025 à 09:00 (CEST) au 30 juillet 2025 à 09:00 (CEST). EcoFlow se réserve le droit de raccourcir ou de prolonger la période promotionnelle à sa seule discrétion et sans préavis.',
        },
        {
            title: '<strong>Éligibilité</strong>',
        },
        {
            title: 'La période promotionnelle est ouverte aux citoyens européens âgés de 18 ans et plus à partir du 25 avril 2025 à 09:00 (CEST) .',
        },

        {
            title: '<strong>Disponibilité</strong>',
        },
        {
            title: `Cette promotion, qui comprend des offres spéciales, des cadeaux et des remises, est disponible exclusivement sur le site officiel <a href="https://fr.ecoflow.com" target="blank"> fr.ecoflow.com. </a> Les achats réalisés sur des plateformes ou sites web autres que <a href="https://fr.ecoflow.com" target="blank"> fr.ecoflow.com </a> ne sont pas éligibles à cette promotion.`,
        },

        {
            title: '<strong>Détails de la promotion</strong>',
        },
        {
            title: "1. En saisissant votre adresse e-mail et en vous abonnant, vous acceptez les conditions générales du marketing par e-mail, vous vous abonnez aux e-mails marketing d'EcoFlow et vous acceptez de recevoir des communications de la part d’EcoFlow.",
        },
        {
            title: "2. Économisez 100 € avec l'offre Early Bird basée sur le prix de détail suggéré par le fabricant (PDSF) :",
        },
        {
            title:
                '<ul>' +
                "<li>EcoFlow WAVE 3 sera lancé le 12 mai 2025 à 9 heures (CEST). EcoFlow GLACIER Classic sera lancé le 29 mai 2025 à 9 heures (CEST). L'offre Early Bird n'est valable que pendant le premier mois du lancement. EcoFlow se réserve le droit d'interrompre, d'annuler ou de modifier l'offre promotionnelle à tout moment durant la période promotionnelle. Tout changement sera annoncé sur le site web officiel d'EcoFlow." +
                '</li>' +
                "<li>Produits éligibles à l'offre Early Bird* :" +
                '<ul>' +
                '<li>EcoFlow WAVE 3 + batterie supplémentaire WAVE 3 (économisez 100 € sur le PDSF en achetant l’offre groupée)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35L + batterie enfichable (économisez 100 € sur le PDSF en achetant l’offre groupée)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45L + batterie enfichable (économisez 100 € sur le PDSF en achetant l’offre groupée)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55L + batterie enfichable (économisez 100 € sur le PDSF en achetant l’offre groupée)' +
                '</li>' +
                '<li>EcoFlow WAVE 3 (économisez 100 € sur le PDSF)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35L (économisez 100 € sur le PDSF)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45L (économisez 100 € sur le PDSF)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55L (économisez 100 € sur le PDSF)' +
                '</li>' +
                '</ul>' +
                '</li>' +
                '<p class="outline-text">    *Cette liste de produits est à titre de référence uniquement. Veuillez vous référer aux fiches produits de EcoFlow WAVE 3 et EcoFlow GLACIER Classic sur <a href="https://fr.ecoflow.com" target="blank"> fr.ecoflow.com. </a> pour des détails précis et à jour.' +
                "<li>Toutes les offres de prévente sont soumises à disponibilité. Une fois le stock épuisé, l'offre prend fin." +
                '</li>' +
                "<li>Sauf indication contraire, l'offre Early Bird ne peut pas être utilisée avec d'autres offres ou promotions en cours sur notre site Web." +
                '</li>' +
                "<li>Les produits éligibles à l'offre Early Bird ne sont pas éligibles aux offres de correspondance de prix de 30 jours." +
                '</li>' +
                "<li>Cette offre ne s'applique pas aux produits reconditionnés." +
                '</li>' +
                '</ul>',
        },
        // {
        //     title: "3. Cette offre ne s'applique pas aux produits reconditionnés.",
        // },
        // {
        //     title: '4. Nombre de commandes et répartition des cadeaux :',
        // },
        // {
        //     title: "<ul><li>Les 200 premières commandes éligibles seront comptabilisées sur les cinq sites officiels EcoFlow suivants : <a href='https://eu.ecoflow.com' target='blank'> eu.ecoflow.com </a>, <a href='https://de.ecoflow.com' target='blank'> de.ecoflow.com </a>, <a href='https://fr.ecoflow.com' target='blank'> fr.ecoflow.com </a>, <a href='https://it.ecoflow.com' target='blank'> it.ecoflow.com </a> et <a href='https://es.ecoflow.com' target='blank'> es.ecoflow.com </a>. Au total, 200 ensembles de cadeaux seront distribués sur ces sites Web. Le décompte commence en fonction de l'annonce du site officiel de l'heure de lancement d'EcoFlow WAVE 3 et GLACIER Classic. Les commandes éligibles seront déterminées par ordre chronologique de paiement.</li></ul>",
        // },

        // {
        //     title: 'Liste des produits éligibles et des cadeaux',
        // },
        // {
        //     title: "<ul><li>Produits éligibles : Climatiseur portable EcoFlow WAVE 3 et ses offres groupées<ul><li>Cadeaux spéciaux :<ul><li>1 sac gamme EcoFlow WAVE (PDSF 79 €)</li><li>1 poignée à sangle velcro EcoFlow (PDSF 39 €)</li></ul></li><li>Quantités disponibles : 200 ensembles</li></ul></li><li>Produits éligibles : Réfrigérateur congélateur portable EcoFlow GLACIER Classic et ses offres groupées<ul><li>Cadeaux spéciaux :<ul><li>1 Chapeau solaire EcoFlow (PDSF 99 €)</li><li>1 mug de camping EcoFlow (PDSF 22 €)</li><p class='outline-text'>* Le Chapeau solaire EcoFlow est disponible en tailles M ou L, attribuées de façon aléatoire selon les stocks. La sélection de taille n'est pas possible.</p></ul></li><li>Quantités disponibles : 200 ensembles</li></ul></li></ul>",
        // },
        // {
        //     title: "5. Une fois les 200  commandes éligibles effectuées, l'offre spéciale pour les 200  premiers achats prendra fin automatiquement, sans notification supplémentaire sur le site web. Une fois les stocks épuisés, les cadeaux ne seront plus disponibles pour les nouvelles commandes.",
        // },
        // {
        //     title: "6. L'offre spéciale pour les 200 premiers achats ne peut être utilisée conjointement avec d'autres offres ou promotions en cours sur notre site Web, sauf indication contraire.",
        // },
        // {
        //     title: "7. Si une commande est admissible aux cadeaux, elle sera automatiquement ajoutée dans les 24 heures suivant le paiement. Les acheteurs peuvent consulter leur e-mail de mise à jour de commande après 24 heures ou s'inscrire à un compte EcoFlow et se connecter au <a href='https://account.ecoflow.com/login?return_to=fr.ecoflow.com/' target='blank'> portail de compte EcoFlow </a> pour confirmer l'ajout de cadeaux à leur commande.",
        // },
        // {
        //     title: '8. Expédition des cadeaux :',
        // },
        // {
        //     title: "<ul><li>Si une commande est une précommande, les cadeaux ne seront pas expédiés avant le climatiseur portable EcoFlow WAVE 3 ou le réfrigérateur congélateur portable EcoFlow GLACIER Classic.</li><li>Lorsque l'EcoFlow WAVE 3 ou EcoFlow GLACIER Classic est réapprovisionné, les cadeaux seront expédiés avec le produit principal.</li></ul>",
        // },
        // {
        //     title: '9. Politique de retour :',
        // },
        // {
        //     title: "<ul><li>Si un client souhaite retourner une commande ou un article pouvant bénéficier de cadeaux, la transaction ne peut être remboursée que si les cadeaux sont également retournés.</li><li>La valeur des cadeaux est basée sur le prix de détail suggéré par le fabricant (PDSF).</li><li>Si le cadeau n'est pas retourné, EcoFlow se réserve le droit de déduire la valeur du cadeau du montant du remboursement.</li></ul>",
        // },
        // {
        //     title: '10. Restrictions relatives aux cadeaux :',
        // },
        // {
        //     title: '<ul><li>Les cadeaux ne peuvent pas être appliqués aux commandes passées avant le début de la période promotionnelle.</li><li>Les cadeaux sont non transférables, non réutilisables et ne peuvent être partagés sans autorisation.</li><li>Les cadeaux ne peuvent être échangés contre aucun autre article, argent comptant ou crédit.</li></ul>',
        // },
        {
            title: '<header><strong>Généralités:</strong></header>',
        },
        {
            title: "1. Si vous rencontrez des problèmes pendant la promotion, veuillez contacter <a  href='mailto:support.eu@ecoflow.com'> support.eu@ecoflow.com </a> pour obtenir de l'aide.",
        },
        {
            title: "2. Dans la mesure permise par la loi applicable, nous pouvons décider de modifier ces règles ou d'annuler la promotion à tout moment. En cas de fraude ou d'abus lié à la promotion, nous nous réservons le droit d'exclure tout client de la promotion.",
        },
        {
            title: "3. Les Participants acceptent d'être liés par les termes et conditions énoncés dans les présentes Conditions générales et comprennent que les décisions d'EcoFlow sont finales et sans appel. Aucune correspondance ni appel ne sera accepté. EcoFlow se réserve le droit de faire l'interprétation finale et définitive de cette promotion.",
        },
        {
            title: "4. Pendant la période promotionnelle, toutes les commandes doivent respecter les conditions du contrat d'achat ainsi que la politique de retour d'EcoFlow.",
        },
        {
            title: "5. Cette promotion n'est pas valable pour les commandes en gros ni pour les distributeurs.",
        },
        {
            title: '6. Tout comportement non autorisé ou frauduleux entraînera la disqualification des Participants.',
        },
        {
            title: '7. Les Participants doivent se conformer à toutes les lois et réglementations applicables.',
        },
        {
            title: "8. EcoFlow se réserve le droit d'interrompre, d'annuler ou de modifier l'offre promotionnelle à tout moment durant la période promotionnelle. Tout changement sera annoncé sur le site web officiel d'EcoFlow.",
        },
        {
            title: "9. Toutes les récompenses de cette promotion sont en quantité limitée et disponibles selon le principe du « premier arrivé, premier servi ». Toute question non traitée ici sera traitée conformément à l'interprétation finale d'EcoFlow.",
        },
        {
            title: "10. EcoFlow ne sera pas responsable des inscriptions tardives qui pourraient survenir pour quelque raison que ce soit, y compris, mais sans s'y limiter, la défaillance de la transmission réseau.",
        },
        {
            title: "11. EcoFlow décline toute responsabilité pour les pertes ou dommages, directs ou indirects, subis par une partie, y compris les Participants, en lien avec cette promotion ou résultant d'actes, d'omissions ou de toute autre manière liée à celle-ci.",
        },
        {
            title: "12. Les Participants acceptent de décharger EcoFlow de toute responsabilité et de renoncer à toute réclamation, que ce soit pour violation de contrat, délit, négligence ou tout autre motif d'action en droit ou en équité, découlant de ou liée de quelque manière que ce soit à cette promotion ou à leur participation.",
        },
        {
            title: "13. Tous les produits et cadeaux (le cas échéant) liés à cette promotion seront expédiés conformément à la Politique de livraison d'EcoFlow, disponible ici : (<a href='https://fr.ecoflow.com/policies/shipping-policy' target='blank'>https://fr.ecoflow.com/policies/shipping-policy</a>)",
        },
        {
            title: "14. Dans certains cas, EcoFlow ne peut accepter ou doit annuler certaines commandes. EcoFlow se réserve le droit, à sa seule discrétion, de refuser ou d'annuler toute commande pour quelque raison que ce soit. Dans de tels cas, EcoFlow n'est pas responsable des imprécisions, erreurs ou conséquences potentielles découlant de l'annulation.",
        },
    ],
    it: [
        {
            title: `<strong>Utilizzo del prodotto: </strong>`,
        },
        {
            title: '[1] Test effettuati in uno spazio di 10 metri cubici a 25 °C. Le prestazioni possono variare in base alle dimensioni dell’ambiente e alla temperatura.',
        },
        {
            title: '[2] Test effettuati in uno spazio di 10 metri cubici a 15 °C. I risultati possono variare in funzione delle condizioni presenti.',
        },
        {
            title: '[3] 8 ore di utilizzo wireless nella modalità Eco in condizioni ottimali. La durata della batteria può variare in base all’utilizzo e alle condizioni ambientali.',
        },
        {
            title: '<header><strong>Termini e condizioni della campagna di lancio di EcoFlow WAVE 3 e GLACIER Classic</strong></header>',
        },
        {
            title: '<strong>Durata della campagna</strong>',
        },
        {
            title: 'La campagna di lancio di EcoFlow WAVE 3 e GLACIER Classic si terrà dalle 09:00 (CET) del 25 aprile 2025 alle 09:00 (CET) del 30 luglio 2025. EcoFlow si riserva il diritto di modificare o estendere il periodo di validità della campagna, a sua esclusiva discrezione e senza alcun preavviso.',
        },
        {
            title: '<strong>Idoneità</strong>',
        },
        {
            title: 'Possono partecipare alla campagna tutti i cittadini europei che hanno almeno 18 anni di età alle 9:00 (CET) del 25 aprile 2025.',
        },

        {
            title: '<strong>Disponibilità</strong>',
        },
        {
            title: `La presente campagna, così come le promozioni, i regali e gli sconti che essa prevede, sono disponibili esclusivamente su <a href="https://it.ecoflow.com" target="blank"> it.ecoflow.com. </a> Gli acquisti effettuati su altre piattaforme o altri siti web non sono idonei a usufruire delle offerte della campagna.`,
        },

        {
            title: '<strong>Dettagli della campagna</strong>',
        },
        {
            title: '1. Fornendo il tuo indirizzo e-mail e iscrivendoti, accetti i termini e le condizioni per l’e-mail marketing, ti iscrivi per ricevere le e-mail di marketing di EcoFlow e acconsenti a ricevere aggiornamenti da EcoFlow.',
        },
        {
            title: '2. L’offerta Early Bird consente di risparmiare 100 € sul prezzo di vendita suggerito dal produttore:',
        },
        {
            title:
                '<ul>' +
                '<li>EcoFlow WAVE 3 verrà lanciato il 12 maggio 2025 alle ore 09:00 (CET). EcoFlow GLACIER Classic verrà lanciato il 29 maggio 2025 alle ore 09:00 (CET). L’offerta Early Bird sarà valida solo durante il primo mese di lancio. EcoFlow si riserva il diritto di interrompere, annullare o modificare la promozione in qualsiasi momento durante il suo periodo di validità. Eventuali modifiche saranno annunciate sul sito web ufficiale EcoFlow.' +
                '</li>' +
                '<li>Prodotti idonei per l’offerta Early Bird*:' +
                '<ul>' +
                '<li>EcoFlow WAVE 3 + Batteria aggiuntiva WAVE 3 (risparmio di 100 € sul prezzo di vendita suggerito dal produttore con l’acquisto in set)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35 L + Batteria plug-in (risparmio di 100 € sul prezzo di vendita suggerito dal produttore con l’acquisto in set)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45 L + Batteria plug-in (risparmio di 100 € sul prezzo di vendita suggerito dal produttore con l’acquisto in set)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55 L + Batteria plug-in (risparmio di 100 € sul prezzo di vendita suggerito dal produttore con l’acquisto in set)' +
                '</li>' +
                '<li>EcoFlow WAVE 3 (risparmio di 100 € sul prezzo di vendita suggerito dal produttore)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35 L (risparmio di 100 € sul prezzo di vendita suggerito dal produttore)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45 L (risparmio di 100 € sul prezzo di vendita suggerito dal produttore)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55 L (risparmio di 100 € sul prezzo di vendita suggerito dal produttore)' +
                '</li>' +
                '</ul>' +
                '</li>' +
                '<p class="outline-text">    * Questo elenco di prodotti viene fornito solo a scopo di riferimento. Consulta le pagine di prodotto di EcoFlow WAVE 3 e EcoFlow GLACIER Classic su <a href="https://it.ecoflow.com" target="blank"> it.ecoflow.com. </a> per informazioni accurate e aggiornate.' +
                '<li>Tutte le promozioni dell’offerta Early Bird sono soggette a disponibilità. All’esaurimento delle scorte dedicate, l’offerta non sarà più disponibile.' +
                '</li>' +
                '<li>Salvo diversamente indicato, l’offerta Early Bird non può essere combinata con altre offerte o promozioni attive sul nostro sito web.' +
                '</li>' +
                '<li>I prodotti idonei per l’offerta Early Bird non sono idonei per le offerte del prezzo più basso per 30 giorni.' +
                '</li>' +
                '<li>I prodotti ricondizionati non sono idonei per questo evento.' +
                '</li>' +
                '</ul>',
        },
        // {
        //     title: '3. I prodotti ricondizionati non sono idonei per questo evento.',
        // },
        // {
        //     title: '4. Conteggio degli ordini e assegnazione dei regali:',
        // },
        // {
        //     title: "<ul><li>I primi 200 ordini idonei verranno conteggiati nei seguenti cinque siti web ufficiali EcoFlow: <a href='https://eu.ecoflow.com' target='blank'> eu.ecoflow.com </a>, <a href='https://de.ecoflow.com' target='blank'> de.ecoflow.com </a>, <a href='https://fr.ecoflow.com' target='blank'> fr.ecoflow.com </a>, <a href='https://it.ecoflow.com' target='blank'> it.ecoflow.com </a> ed <a href='https://es.ecoflow.com' target='blank'> es.ecoflow.com </a>. In questi siti web verrà distribuito un totale di 200 set di regali in omaggio. Il conteggio avrà inizio in base all’annuncio della data di lancio di EcoFlow WAVE 3 e GLACIER Classic sul sito web ufficiale. Gli ordini idonei verranno determinati in base all’ordine cronologico di pagamento.</li></ul>",
        // },

        // {
        //     title: 'Elenco dei prodotti idonei e dei regali in omaggio',
        // },
        // {
        //     title: '<ul><li>Prodotti idonei: condizionatore d’aria portatile EcoFlow WAVE 3 e relativi set<ul><li>Regali dedicati:<ul><li>1 borsa per serie EcoFlow WAVE (prezzo di vendita suggerito: 79 €)</li><li>1 maniglia con velcro EcoFlow (prezzo di vendita suggerito: 39 €)</li></ul></li><li>Quantità disponibili: 200 set</li></ul></li><li>Prodotti idonei: frigorifero-freezer portatile EcoFlow GLACIER Classic e relativi set<ul><li>Regali dedicati:<ul><li>1 Cappello solare EcoFlow* (prezzo di vendita suggerito: 99 €)</li><li>1 tazza da campeggio EcoFlow (prezzo di vendita suggerito: 22 €)</li><p class="outline-text">*Il Cappello solare EcoFlow viene fornito in misure casuali (M o L) in base alla disponibilità di magazzino. Non è possibile selezionare la taglia.</p></ul></li><li>Quantità disponibili: 200 set</li></ul></li></ul>',
        // },
        // {
        //     title: '5. Una volta raggiunti i 200 ordini idonei, l’offerta speciale per i primi 200 acquisti terminerà automaticamente senza ulteriore avviso. Una volta esauriti gli articoli disponibili per un regalo, quest’ultimo non sarà più disponibile per gli ordini successivi.',
        // },
        // {
        //     title: '6. Se non diversamente indicato, l’offerta speciale per i primi 200 acquisti non è cumulabile con altre offerte o promozioni in corso sul nostro sito web.',
        // },
        // {
        //     title: "7. Se un ordine risulta idoneo alla ricezione di regali in omaggio, questi ultimi verranno aggiunti automaticamente entro 24 ore dal pagamento. Per verificare l’aggiunta dei regali in omaggio al proprio ordine, gli acquirenti possono controllare l’e-mail con l’aggiornamento sull’ordine dopo 24 ore o registrare un account EcoFlow e accedere al <a href='https://account.ecoflow.com/login?return_to=it.ecoflow.com/' target='blank'>  Portale degli account EcoFlow. </a>",
        // },
        // {
        //     title: '8. Spedizione dei regali in omaggio:',
        // },
        // {
        //     title: '<ul><li>In caso di pre-ordini, i regali in omaggio non verranno spediti in anticipo rispetto al condizionatore d’aria portatile EcoFlow WAVE 3 o al frigorifero-freezer portatile EcoFlow GLACIER Classic.</li><li>Non appena le scorte di EcoFlow WAVE 3 o EcoFlow GLACIER Classic verranno rifornite, i regali in omaggio verranno spediti insieme al prodotto principale.</li></ul>',
        // },
        // {
        //     title: '9. Politica di reso:',
        // },
        // {
        //     title: '<ul><li>Qualora un cliente desideri effettuare il reso di un ordine o di un articolo che ha dato diritto a regali in omaggio, la transazione potrà essere rimborsata solo se verranno restituiti anche i regali in omaggio.</li><li>Il valore dei regali in omaggio si basa sul prezzo di vendita suggerito dal produttore.</li><li>In caso di mancata restituzione dei regali in omaggio, EcoFlow si riserva di diritto di detrarre il relativo valore dall’importo del rimborso.</li></ul>',
        // },
        // {
        //     title: '10. Restrizioni relative ai regali in omaggio:',
        // },
        // {
        //     title: '<ul><li>I regali in omaggio non possono essere applicati a ordini effettuati prima dell’inizio della campagna.</li><li>I regali in omaggio non sono trasferibili né riutilizzabili e non è ne consentita la condivisione senza autorizzazione.</li><li>I regali in omaggio non possono essere scambiati con nessun altro articolo, né con denaro o credito.</li></ul>',
        // },
        {
            title: '<header><strong>Disposizioni generali:</strong></header>',
        },
        {
            title: "1. Per qualsiasi problema riscontrato durante la promozione, si prega di contattare l’assistenza all’indirizzo <a  href='mailto:support.eu@ecoflow.com'> support.eu@ecoflow.com.</a>",
        },
        {
            title: '2. Nella misura consentita dalla legge applicabile, EcoFlow può decidere in qualsiasi momento di modificare queste regole o di annullare la promozione. In caso di frode o abuso in relazione alla promozione, ci riserviamo il diritto di escludere qualsiasi cliente dalla promozione.',
        },
        {
            title: '3. I partecipanti alla promozione accettano di essere vincolati dai termini e condizioni qui disposti e riconoscono che le decisioni di EcoFlow sono definitive e vincolanti. Non sarà intrattenuta alcuna corrispondenza e le decisioni si intendono inappellabili. EcoFlow si riserva il diritto di interpretazione ultima e definitiva per la presente campagna.',
        },
        {
            title: '4. Durante la promozione, tutti gli ordini devono essere conformi al contratto di acquisto e alla politica di reso di EcoFlow.',
        },
        {
            title: '5. La promozione non si applica agli ordini all’ingrosso o effettuati da distributori.',
        },
        {
            title: '6. Qualsiasi comportamento non autorizzato o fraudolento comporterà la squalifica dei partecipanti.',
        },
        {
            title: '7. I partecipanti sono tenuti a rispettare tutte le leggi e le normative vigenti.',
        },
        {
            title: '8. EcoFlow si riserva il diritto di interrompere, annullare o modificare la promozione in qualsiasi momento durante il suo periodo di validità. Eventuali modifiche saranno annunciate sul sito web ufficiale EcoFlow.',
        },
        {
            title: '9. Tutti i premi di questa promozione sono in quantità limitata e sono disponibili in base all’ordine di arrivo dell’ordine di acquisto. Qualsiasi questione non contemplata nelle presenti disposizioni sarà gestita secondo l’interpretazione finale di EcoFlow.',
        },
        {
            title: '10. EcoFlow non si assume alcuna responsabilità per ritardi negli inserimenti dovuti a qualunque motivo, inclusi, in via esemplificativa ma non esaustiva, errori di trasmissione di rete.',
        },
        {
            title: '11. EcoFlow non sarà responsabile per eventuali perdite o danni diretti o indiretti subiti da qualsiasi parte, compresi i partecipanti, connessi a o derivanti da atti o omissioni di qualunque genere nel contesto di questa campagna o altrimenti riconducibili alla stessa.',
        },
        {
            title: '12. I partecipanti accettano di sollevare ed esonerare EcoFlow da qualsiasi responsabilità e reclamo, ivi inclusi violazione del contratto, illecito civile, negligenza o qualsiasi altra causa di azione legale o di equità, derivante da o in qualsiasi modo collegata a questa campagna o alla partecipazione alla campagna.',
        },
        {
            title: "13. Tutti i prodotti e gli eventuali regali in omaggio correlati a questa promozione verranno spediti in conformità alla politica di spedizione di EcoFlow (<a href='https://it.ecoflow.com/policies/shipping-policy'target='blank'>https://it.ecoflow.com/policies/shipping-policy</a>)",
        },
        {
            title: '14. In alcune circostanze, può succedere che EcoFlow non possa accettare o debba annullare determinati ordini. EcoFlow si riserva il diritto di rifiutare o annullare, a sua completa discrezione, qualsiasi ordine per qualsiasi motivo. In tali casi, EcoFlow non è responsabile per eventuali imprecisioni, errori o potenziali conseguenze derivanti dall’annullamento.',
        },
    ],
    es: [
        {
            title: `<strong>Uso del producto: </strong>`,
        },
        {
            title: '[1] Probado en un espacio de 10 metros cúbicos a 25 ℃. El rendimiento puede variar según el tamaño y la temperatura de la habitación.',
        },
        {
            title: '[2] Probado en un espacio de 10 metros cúbicos a 15 ℃. Los resultados pueden variar dependiendo de las condiciones.',
        },
        {
            title: '[3] 8 horas de uso inalámbrico en modo Eco en condiciones óptimas. La duración de la batería puede variar según el uso y el entorno.',
        },
        {
            title: '<header><strong>Términos y condiciones de la Campaña de lanzamiento de EcoFlow WAVE 3 & GLACIER Classic</strong></header>',
        },
        {
            title: '<strong>Duración de la campaña</strong>',
        },
        {
            title: 'La campaña de lanzamiento de EcoFlow WAVE 3 & GLACIER Classic estará vigente desde el 25 de abril de 2025 a las 9:00 AM (CET) hasta el 30 de julio de 2025 a las 9:00 AM (CET). EcoFlow se reserva el derecho de modificar o prorrogar el tiempo de duración de la campaña a su exclusivo criterio y sin previo aviso.',
        },
        {
            title: '<strong>Requisitos de participación</strong>',
        },
        {
            title: 'La campaña está abierta a todos los ciudadanos europeos mayores de 18 años a partir del 25 de abril de 2025 a las 9:00 AM (CET).',
        },

        {
            title: '<strong>Disponibilidad</strong>',
        },
        {
            title: `Esta campaña, que incluye promociones, regalos y descuentos, está disponible exclusivamente en <a href="https://es.ecoflow.com" target="blank"> es.ecoflow.com. </a> Las compras realizadas en otras plataformas o sitios web no serán elegibles para las ofertas de la campaña.`,
        },

        {
            title: '<strong>Detalles de la campaña</strong>',
        },
        {
            title: '1. Al proporcionar tu dirección de correo electrónico y confirmar tu suscripción, aceptas los términos y condiciones de marketing por correo electrónico, te suscribes a las comunicaciones comerciales de EcoFlow y das tu consentimiento para recibir actualizaciones de EcoFlow.',
        },
        {
            title: '2. Ahorra 100 € con la oferta Early Bird, basada en el Precio de Venta Sugerido (PVP):',
        },
        {
            title:
                '<ul>' +
                '<li>EcoFlow WAVE 3 se lanzará el 12 de mayo de 2025 a las 9:00 (CET). EcoFlow GLACIER Classic se lanzará el 29 de mayo de 2025 a las 9:00 (CET). La oferta Early Bird solo estará disponible durante el primer mes tras el lanzamiento. EcoFlow se reserva el derecho de detener, cancelar o modificar la promoción en cualquier momento durante su duración. Cualquier cambio se anunciará en el sitio web oficial de EcoFlow.' +
                '</li>' +
                '<li>Productos incluidos en la oferta Early Bird*:' +
                '<ul>' +
                '<li>EcoFlow WAVE 3 + batería adicional (ahorra 100 € con el pack)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35 L + batería enchufable (ahorra 100 € con el pack)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45 L + batería enchufable (ahorra 100 € con el pack)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55 L + batería enchufable (ahorra 100 € con el pack)' +
                '</li>' +
                '<li>EcoFlow WAVE 3 (ahorra 100 €)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 35 L (ahorra 100 €)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 45 L (ahorra 100 €)' +
                '</li>' +
                '<li>EcoFlow GLACIER Classic 55 L (ahorra 100 €)' +
                '</li>' +
                '</ul>' +
                '</li>' +
                '<p class="outline-text">    *Esta lista de productos se incluye únicamente a modo de referencia. Consulta las páginas de los productos EcoFlow WAVE 3 y EcoFlow GLACIER Classic en <a href="https://es.ecoflow.com" target="blank"> es.ecoflow.com. </a> para obtener información precisa y actualizada.' +
                '<li>Todas las ofertas Early Bird están sujetas a disponibilidad. Una vez que se agote el stock, la oferta ya no estará disponible.' +
                '</li>' +
                '<li>Salvo que se indique lo contrario, la oferta Early Bird no es acumulable con otras promociones activas en nuestra web.' +
                '</li>' +
                '<li>Los productos incluidos en la oferta no son válidos para la garantía de igualación de precios de 30 días.' +
                '</li>' +
                '<li>Los productos reacondicionados no son elegibles para esta promoción.' +
                '</li>' +
                '</ul>',
        },
        // {
        //     title: '3. Los productos reacondicionados no son elegibles para esta promoción.',
        // },
        // {
        //     title: '4. Cómputo de pedidos y asignación de regalos:',
        // },
        // {
        //     title: "<ul><li>Se contarán los primeros 200 pedidos entre los siguientes cinco sitios web oficiales de EcoFlow: <a href='https://eu.ecoflow.com' target='blank'> eu.ecoflow.com </a>, <a href='https://de.ecoflow.com' target='blank'> de.ecoflow.com </a>, <a href='https://fr.ecoflow.com' target='blank'> fr.ecoflow.com </a>, <a href='https://it.ecoflow.com' target='blank'> it.ecoflow.com </a> y <a href='https://es.ecoflow.com' target='blank'> es.ecoflow.com </a>. Se distribuirán 200 sets de regalos entre estos sitios web. El cómputo de pedidos comenzará con el anuncio oficial del lanzamiento de EcoFlow WAVE 3 y GLACIER Classic en la web. Los pedidos elegibles se determinarán por orden cronológico de pago.</li></ul>",
        // },

        // {
        //     title: 'Lista de productos y regalos gratuitos',
        // },
        // {
        //     title: '<ul><li>Productos elegibles: Aire acondicionado portátil EcoFlow WAVE 3 y paquetes relacionados<ul><li>Regalos exclusivos:<ul><li>1 x Bolsa de la serie EcoFlow WAVE (precio de venta sugerido: 79 €)</li><li>1 x Asa con correa de velcro EcoFlow (precio de venta sugerido: 39 €)</li></ul></li><li>Cantidades disponibles: 200 sets</li></ul></li><li>Productos elegibles: Nevera portátil EcoFlow GLACIER Classic y paquetes relacionados<ul><li>Regalos exclusivos:<ul><li>1 x Sombrero solar EcoFlow* (precio de venta sugerido: 99 €)</li><li>1 x Taza de camping EcoFlow (precio de venta sugerido: 22 €)</li><p class="outline-text">*El Sombrero solar EcoFlow se proporciona en tallas aleatorias (M o L) según la disponibilidad de stock. No es posible seleccionar la talla.</p></ul></li><li>Cantidades disponibles: 200 sets</li></ul></li></ul>',
        // },
        // {
        //     title: '5. Cuando se alcancen 200 pedidos, la promoción se dará por finalizada automáticamente sin previo aviso. Una vez agotado el stock de regalos, ya no estarán disponibles para nuevos pedidos.',
        // },
        // {
        //     title: '6. La promoción de los 200 primeros pedidos no se puede combinar con otras ofertas o descuentos disponibles en el sitio web, salvo que se indique lo contrario.',
        // },
        // {
        //     title: "7. Si un pedido es elegible para los regalos, estos se añadirán automáticamente en un plazo de 24 horas tras el pago. Los compradores podrán comprobar el correo de actualización de su pedido después de 24 horas o registrarse en una cuenta de EcoFlow e iniciar sesión en el <a href='https://account.ecoflow.com/login?return_to=es.ecoflow.com/' target='blank'>  Portal de Cuenta EcoFlow </a>para confirmar la adición de los regalos gratuitos a su pedido.",
        // },
        // {
        //     title: '8. Envío de regalos:',
        // },
        // {
        //     title: '<ul><li>Si el pedido es una precompra, los regalos gratuitos no se enviarán antes que el producto principal (Aire acondicionado portátil EcoFlow WAVE 3 o Nevera portátil EcoFlow GLACIER Classic).</li><li>Una vez que el producto principal (Aire acondicionado portátil EcoFlow WAVE 3 o Nevera portátil EcoFlow GLACIER Classic) esté en stock nuevamente, los regalos se enviarán junto con él.</li></ul>',
        // },
        // {
        //     title: '9. Política de devoluciones',
        // },
        // {
        //     title: '<ul><li>Si un cliente desea devolver un pedido que incluía regalos gratuitos, la devolución solo será posible si se devuelven también los regalos.</li><li>El valor de los regalos se calculará en función de su Precio de venta sugerido.</li><li>Si los regalos no se devuelven, EcoFlow se reserva el derecho de descontar su valor del importe del reembolso.</li></ul>',
        // },
        // {
        //     title: '10. Restricciones aplicadas a los regalos:',
        // },
        // {
        //     title: '<ul><li>Los regalos no se pueden aplicar a pedidos realizados antes del inicio de la campaña.</li><li>Los regalos no son transferibles, ni reutilizables, y no se pueden compartir sin autorización.</li><li>Los regalos no se pueden sustituir por ningún otro artículo, dinero en efectivo ni créditos.</li></ul>',
        // },
        {
            title: '<header><strong>Condiciones generales:</strong></header>',
        },
        {
            title: "1. Si tienes algún problema durante la promoción, ponte en contacto con <a  href='mailto:support.eu@ecoflow.com'> support.eu@ecoflow.com</a> para obtener ayuda.",
        },
        {
            title: '2. En la medida en que lo permita la ley aplicable, podremos decidir modificar estas reglas o cancelar la promoción en cualquier momento. Si existe algún fraude o abuso relacionado con la promoción, nos reservamos el derecho de excluir a cualquier cliente de la promoción.',
        },
        {
            title: '3. Los participantes en la promoción aceptan los términos y condiciones establecidos en este documento y entienden que las decisiones de EcoFlow son definitivas y vinculantes. No se contemplará ningún tipo de comunicación ni recurso. EcoFlow se reserva el derecho de hacer la interpretación final y definitiva de esta campaña.',
        },
        {
            title: '4. Durante la promoción de rebajas, todos los pedidos deben cumplir el acuerdo de compra y la política de devoluciones de EcoFlow.',
        },
        {
            title: '5. La promoción de rebajas no es aplicable a los pedidos de mayoristas o distribuidores.',
        },
        {
            title: '6. Cualquier comportamiento no autorizado o fraudulento supondrá la descalificación de los participantes.',
        },
        {
            title: '7. Los participantes deben cumplir con todas las leyes y regulaciones aplicables.',
        },
        {
            title: '8. EcoFlow se reserva el derecho de detener, cancelar o cambiar la promoción en cualquier momento durante el transcurso de la misma. Cualquier cambio se anunciará en el sitio web oficial de EcoFlow.',
        },
        {
            title: '9. Todos los premios de esta promoción están limitados en cantidad y están disponibles por orden de llegada. Cualquier asunto no cubierto en este documento será tratado de acuerdo con la interpretación final de EcoFlow.',
        },
        {
            title: '10. EcoFlow no asumirá responsabilidad alguna por las participaciones fuera de plazo que puedan producirse por cualquier motivo, incluidos, entre otros, errores o fallos en la transmisión de la red o internet.',
        },
        {
            title: '11. EcoFlow no se hace responsable de ningún daño o pérdida, directa o indirecta, sufrida por cualquier parte, incluidos los participantes, en relación con esta campaña o como resultado de actos u omisiones derivados de esta.',
        },
        {
            title: '12. Los participantes aceptan eximir y liberar de toda reclamación y responsabilidad a EcoFlow, incluyendo el incumplimiento de contrato, agravio, negligencia o cualquier otra causa de demanda a tenor de la ley o la equidad que surja a raíz de esta campaña o la inscripción del participante en la campaña, o que esté de alguna manera relacionada.',
        },
        {
            title: "13. Todos los productos y regalos gratuitos (si procede) relacionados con esta promoción se enviarán de acuerdo con la Política de envíos de EcoFlow (<a href='https://es.ecoflow.com/policies/shipping-policy'target='blank'>https://es.ecoflow.com/policies/shipping-policy</a>)",
        },
        {
            title: '14. Puede haber casos en los que EcoFlow no pueda aceptar o deba cancelar ciertos pedidos. EcoFlow se reserva el derecho de cancelar pedidos en cualquier momento si lo considera necesario. En caso de cancelación, EcoFlow no se hace responsable de errores, inexactitudes o cualquier otra consecuencia derivada de la anulación del pedido.',
        },
    ],
    us: [
        {
            title: `<strong>Product Usage: </strong>`,
        },
        {
            title: '[1] Tested in a 10 cubic meter space at 77°F. Performance may vary with room size and temperature.',
        },
        {
            title: '[2] Tested in a 10 cubic meter space at 60°F. Results may differ depending on conditions.',
        },
        {
            title: '[3] 8 hours of wireless use in Eco Mode under optimal conditions. Battery life may vary based on usage and environment. ',
        },
    ],
    ca: [
        {
            title: `<strong>Product Usage: </strong>`,
        },
        {
            title: '[1] Tested in a 10 cubic meter space at 25°C. Performance may vary with room size and temperature.',
        },
        {
            title: '[2] Tested in a 10 cubic meter space at 25°C. Results may differ depending on conditions.',
        },
        {
            title: '[3] 8 hours of wireless use in Eco Mode under optimal conditions. Battery life may vary based on usage and environment. ',
        },
    ],
    au: [
        {
            title: <strong>T&C: </strong>,
        },
        {
            title: 'All the test results displayed on the page are based on our internal testing, subject to different conditions, including temperature variations, humidity levels, and equipment calibration standards. Please note that these results are provided for informational purposes only and should not be considered as conclusive evidence for all scenarios. Data was tested in a controlled laboratory environment and actual user experience may vary.',
        },
        {
            title: '1. The runtime is based on laboratory tests conducted with common household appliances under normal room temperature conditions. The "double runtime" claim specifically refers to tests using a 3W light or Wi-Fi router.',
        },
        {
            title: '2. The noise level data is based on laboratory tests conducted at a room temperature of 89.6°F (32°C). Actual use may have slight deviations due to variations in the real environment.',
        },
        {
            title: '3. The input and output wattage of the Smart Extra Battery will decrease to 100W when ambient temperature is higher than 95°F (35°C).',
        },
        {
            title: '4. The IP54 water-resistance rating applies only to the battery pack, not the entire package. It does not prevent water immersion but can prevent fire or explosion in the event of a short circuit if the battery is splashed with water or rain, ensuring user safety and property protection',
        },
    ],
};
